import { render, staticRenderFns } from "./MarkdownText.vue?vue&type=template&id=2f8277ad&scoped=true"
import script from "./MarkdownText.vue?vue&type=script&lang=js"
export * from "./MarkdownText.vue?vue&type=script&lang=js"
import style0 from "./MarkdownText.vue?vue&type=style&index=0&id=2f8277ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8277ad",
  null
  
)

export default component.exports